export const Config = {
    apiUrl: 'https://api.skani.xyz',
    appUrl: 'https://app.skani.xyz',
    oryUrl: "https://auth.skani.xyz",
    prodokLink: "https://prodok.link"
};
